(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frontrowMD"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const base = 'https://app.thefrontrowhealth.com';

    function node(tag, className, value) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (value) element.textContent = value;
      return element;
    }

    function safeAvatar(value) {
      try {
        const url = new URL(value);
        return url.protocol === 'https:' && url.hostname === 'assets.app.thefrontrowhealth.com' ? url.href : null;
      } catch {
        return null;
      }
    }

    function reviewCard(source) {
      const name = source.querySelector('.ce-review-card--name')?.textContent?.trim();
      const body = source.querySelector('.ce-review-card--body')?.textContent?.trim();
      if (!name || !body) return null;

      const card = node('article', 'mirai-fr__card');
      card.append(node('span', 'mirai-fr__verified', 'Verified Clinician'));

      const clinician = node('div', 'mirai-fr__clinician');
      const avatarUrl = safeAvatar(source.querySelector('.ce-review-card--avatar')?.getAttribute('src'));
      if (avatarUrl) {
        const avatar = node('img', 'mirai-fr__avatar');
        avatar.src = avatarUrl;
        avatar.alt = '';
        avatar.loading = 'lazy';
        clinician.append(avatar);
      }
      const identity = node('div');
      identity.append(node('div', 'mirai-fr__clinician-name', name));
      identity.append(node('div', 'mirai-fr__specialty', source.querySelector('.ce-review-card--specialty')?.textContent?.trim()));
      clinician.append(identity);
      card.append(clinician);

      const headline = source.querySelector('.ce-review-card--headline')?.textContent?.trim();
      if (headline) card.append(node('h3', '', headline));

      const review = node('p', 'mirai-fr__body mirai-fr__body--clamped', body);
      const toggle = node('button', 'mirai-fr__read-more', 'Read full review');
      toggle.type = 'button';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.addEventListener('click', () => {
        const expanded = review.classList.toggle('mirai-fr__body--clamped') === false;
        toggle.textContent = expanded ? 'Show less' : 'Read full review';
        toggle.setAttribute('aria-expanded', String(expanded));
      });
      card.append(review, toggle);

      const tags = [...source.querySelectorAll('.ce-review-card--highlights .highlight')];
      if (tags.length) {
        const tagRow = node('div', 'mirai-fr__tags');
        tags.forEach(tag => tagRow.append(node('span', 'mirai-fr__tag', tag.textContent.trim())));
        card.append(tagRow);
      }

      const citations = [...source.querySelectorAll('.cp-citation-tooltip-item')];
      if (citations.length) {
        const details = node('details', 'mirai-fr__sources');
        details.append(node('summary', '', citations.length === 1 ? '1 research source' : `${citations.length} research sources`));
        const list = node('ul');
        citations.forEach(citation => {
          const title = citation.querySelector('.cp-citation-tooltip-title')?.textContent?.trim();
          const publication = citation.querySelector('.cp-citation-tooltip-authors')?.textContent?.trim();
          if (title) list.append(node('li', '', `${title}${publication ? ` — ${publication}` : ''}`));
        });
        details.append(list);
        card.append(details);
      }
      return card;
    }

    function loadReviewDocument(workerUrl, productId) {
      return new Promise((resolve, reject) => {
        if (!workerUrl) return reject(new Error('Cloudflare Worker URL is not configured'));
        let endpoint;
        try {
          endpoint = new URL(workerUrl);
          if (endpoint.protocol !== 'https:') throw new Error('Worker URL must use HTTPS');
        } catch (error) {
          return reject(error);
        }

        const registry = window.MiraiFrontrowReviews ||= { pending: new Map() };
        registry.receive ||= (requestId, html) => {
          const pending = registry.pending.get(requestId);
          if (pending) pending(html);
        };
        const requestId = `fr${Date.now()}${Math.random().toString(36).slice(2)}`;
        endpoint.searchParams.set('product_id', productId);
        endpoint.searchParams.set('request_id', requestId);
        const script = document.createElement('script');
        script.async = true;
        script.src = endpoint.href;
        let settled = false;
        const finish = (error, html) => {
          if (settled) return;
          settled = true;
          clearTimeout(timer);
          registry.pending.delete(requestId);
          script.remove();
          if (error) reject(error);
          else resolve(new DOMParser().parseFromString(html, 'text/html'));
        };
        registry.pending.set(requestId, html => finish(null, html));
        const timer = setTimeout(() => finish(new Error('Cloudflare Worker timed out')), 12000);
        script.onerror = () => finish(new Error('Cloudflare Worker request failed'));
        script.onload = () => {
          if (!settled) finish(new Error('Cloudflare Worker returned no review data'));
        };
        document.head.append(script);
      });
    }

    function initCarousel(section, reviews) {
      if (section.dataset.layout !== 'carousel') return;
      const controls = section.querySelector('[data-carousel-controls]');
      const previous = section.querySelector('[data-carousel-prev]');
      const next = section.querySelector('[data-carousel-next]');
      const cards = [...reviews.querySelectorAll('.mirai-fr__card')];
      if (!controls || !cards.length) return;
      section.classList.toggle('mirai-fr--multiple', cards.length > 1);

      const update = () => {
        const maxScroll = reviews.scrollWidth - reviews.clientWidth;
        controls.hidden = cards.length < 2 || maxScroll <= 1;
        previous.disabled = reviews.scrollLeft <= 1;
        next.disabled = reviews.scrollLeft >= cards[cards.length - 1].offsetLeft - cards[0].offsetLeft - 1;
      };
      const move = direction => {
        const step = cards[1]?.offsetLeft - cards[0].offsetLeft || reviews.clientWidth;
        const index = Math.round(reviews.scrollLeft / step);
        const target = cards[Math.max(0, Math.min(cards.length - 1, index + direction))];
        reviews.scrollTo({ left: target.offsetLeft - cards[0].offsetLeft, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      reviews.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(reviews);
      update();
    }

    function init(section) {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const productId = section.dataset.frontrowProductId;
      const widgetId = section.dataset.frontrowWidgetId;
      const workerUrl = section.dataset.workerUrl;
      const faqUrl = `${base}/api/widgets/testimonials?presentation_type=qual&product_id=${encodeURIComponent(productId)}&id=${encodeURIComponent(widgetId)}`;
      const reviews = section.querySelector('[data-reviews]');
      const note = section.querySelector('[data-research-note]');
      const dialog = section.querySelector('[data-faq-dialog]');
      const faqFrame = section.querySelector('[data-faq-frame]');

      loadReviewDocument(workerUrl, productId).then(source => {
        const cards = [...source.querySelectorAll('.ce-review-card')].map(reviewCard).filter(Boolean);
        if (!cards.length) {
          section.hidden = true;
          return;
        }
        reviews.replaceChildren(...cards);
        initCarousel(section, reviews);
        const footnote = source.querySelector('.ce-research-footnote--text')?.textContent?.trim();
        if (footnote) {
          note.textContent = `† ${footnote}`;
          note.hidden = false;
        }
      }).catch(error => {
        console.error('FrontrowMD reviews could not be loaded', error);
        reviews.textContent = 'Clinician reviews are temporarily unavailable.';
      });

      section.querySelector('[data-learn-more]').addEventListener('click', () => {
        if (!faqFrame.hasAttribute('src')) faqFrame.src = faqUrl;
        dialog.showModal();
      });

      window.addEventListener('message', event => {
        if (event.origin !== base || event.source !== faqFrame.contentWindow) return;
        if (event.data === 'CLOSE_ALL_MODALS' || event.data === 'CLOSE_TESTIMONIALS_MODAL') dialog.close();
      });

      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
    }

    function initAll() {
      document.querySelectorAll('.mirai-fr[data-frontrow-product-id]').forEach(init);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll, { once: true });
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
const HEADER_OVERLAY_HERO_SELECTORS = '.deferred-hero, .banner, .video-section, .slideshow';
const HEADER_OVERLAY_SCROLL_THRESHOLD = 20;

function isHeroFirstSection() {
  const firstSection = document.querySelector('#MainContent > .shopify-section:first-child');
  if (!firstSection) return false;
  return !!firstSection.querySelector(HEADER_OVERLAY_HERO_SELECTORS);
}

let announcementResizeObserver = null;
let promobarMutationObserver = null;
let promobarMutationRaf = null;

function isVisibleBarElement(el) {
  if (!el) return false;
  const rect = el.getBoundingClientRect();
  const hasSize = el.offsetHeight > 0 || rect.height > 0;
  if (!hasSize) return false;
  const style = window.getComputedStyle(el);
  return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
}

function getBarHeight(el) {
  if (!el) return 0;
  const rect = el.getBoundingClientRect();
  return Math.max(el.offsetHeight, rect.height);
}

function getNativeAnnouncementSection() {
  const utilityBar = document.querySelector('.utility-bar');
  if (utilityBar) {
    return utilityBar.closest('.shopify-section');
  }

  const announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    return announcementBar.closest('.shopify-section');
  }

  return document.querySelector('.announcement-bar-section')
    || document.querySelector('.shopify-section-group-header-group .announcement-bar-section');
}

function getQskPromobarCandidates() {
  return Array.from(document.querySelectorAll('.qsk-promobar__single-bar, .qsk-promobar__wrapper, [class*="qsk-promobar__"]')).filter(function(el) {
    return el !== document.body && el !== document.documentElement;
  });
}

function getQskPromobar() {
  const singleBar = document.querySelector('.qsk-promobar__single-bar');
  if (singleBar && getBarHeight(singleBar) > 0) return singleBar;

  const candidates = getQskPromobarCandidates();
  const visible = candidates.find(function(el) {
    return isVisibleBarElement(el);
  });
  if (visible) return visible;

  const withHeight = candidates.filter(function(el) {
    return getBarHeight(el) > 0;
  });
  if (withHeight.length) {
    return withHeight.sort(function(a, b) {
      return getBarHeight(b) - getBarHeight(a);
    })[0];
  }

  return null;
}

function isQskPromobarInserted() {
  return document.body && document.body.classList.contains('qsk-promobar--inserted');
}

function isQskPromobarActive() {
  const qskPromobar = getQskPromobar();
  return isVisibleBarElement(qskPromobar) || (isQskPromobarInserted() && !!qskPromobar);
}

function isUsingQskPromobar() {
  return isQskPromobarActive();
}

function getBarMeasureElement(section) {
  if (!section) return null;

  if (section.classList && section.classList.contains('qsk-promobar__single-bar')) {
    return section;
  }

  if (section.classList && Array.from(section.classList).some(function(className) {
    return className.indexOf('qsk-promobar') !== -1;
  })) {
    return section;
  }

  const qskPromobar = section.querySelector('.qsk-promobar__single-bar')
    || section.querySelector('[class*="qsk-promobar__"]');
  if (qskPromobar) return qskPromobar;

  return section.querySelector('.announcement-bar')
    || section.querySelector('announcement-bar')
    || section;
}

function isQskPromobarStickyEl(measureEl) {
  if (!measureEl || getBarHeight(measureEl) <= 0) return false;
  if (measureEl.classList.contains('qsk-promobar--unstick')) return false;
  return isBarSticky(measureEl);
}

function isBarSticky(measureEl) {
  if (!measureEl || getBarHeight(measureEl) <= 0) return false;

  const position = window.getComputedStyle(measureEl).position;
  if (position === 'sticky' || position === 'fixed') return true;

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop <= 10) return false;

  const rect = measureEl.getBoundingClientRect();
  return rect.top <= 0 && rect.bottom > 0;
}

function getEffectiveBarHeight(section, stickyCheck) {
  if (!section) return 0;

  const measureEl = getBarMeasureElement(section);
  const fullHeight = getBarHeight(measureEl || section);
  if (fullHeight <= 0) return 0;

  const isSticky = typeof stickyCheck === 'function'
    ? stickyCheck(measureEl || section)
    : isBarSticky(measureEl || section);
  if (isSticky) return fullHeight;

  const rect = (measureEl || section).getBoundingClientRect();
  if (rect.bottom <= 0) return 0;

  return fullHeight;
}

function getNativeAnnouncementHeight() {
  const nativeSection = getNativeAnnouncementSection();
  if (!isVisibleBarElement(nativeSection)) return 0;
  return getEffectiveBarHeight(nativeSection, isBarSticky);
}

function getQskPromobarHeight() {
  const qskPromobar = getQskPromobar();
  if (!qskPromobar || (!isVisibleBarElement(qskPromobar) && !isQskPromobarInserted())) return 0;
  return getEffectiveBarHeight(qskPromobar, isQskPromobarStickyEl);
}

function getCombinedAnnouncementHeight() {
  return getNativeAnnouncementHeight() + getQskPromobarHeight();
}

function hasStickyTopBar() {
  const nativeSection = getNativeAnnouncementSection();
  if (isVisibleBarElement(nativeSection) && isBarSticky(getBarMeasureElement(nativeSection))) {
    return true;
  }

  const qskPromobar = getQskPromobar();
  return isQskPromobarStickyEl(qskPromobar);
}

function getAnnouncementSection() {
  const nativeSection = getNativeAnnouncementSection();
  if (isVisibleBarElement(nativeSection)) {
    return nativeSection;
  }

  const qskPromobar = getQskPromobar();
  if (qskPromobar && (isVisibleBarElement(qskPromobar) || isQskPromobarInserted())) {
    return qskPromobar;
  }

  return null;
}

function updateAnnouncementBarOffset() {
  const height = getCombinedAnnouncementHeight();
  const qskPromobar = getQskPromobar();

  document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);

  if (height > 0) {
    document.body.classList.add('has-announcement-bar');
  } else {
    document.body.classList.remove('has-announcement-bar');
  }

  if (isQskPromobarActive() && isQskPromobarStickyEl(qskPromobar)) {
    document.body.classList.add('qsk-promobar-sticky');
  } else {
    document.body.classList.remove('qsk-promobar-sticky');
  }
}

function observeAnnouncementBarResize(onResize) {
  if (typeof ResizeObserver === 'undefined') return;

  if (announcementResizeObserver) {
    announcementResizeObserver.disconnect();
  }

  announcementResizeObserver = new ResizeObserver(function() {
    updateAnnouncementBarOffset();
    if (typeof onResize === 'function') onResize();
  });

  const nativeSection = getNativeAnnouncementSection();
  if (isVisibleBarElement(nativeSection)) {
    announcementResizeObserver.observe(nativeSection);
  }

  const qskPromobar = getQskPromobar();
  if (qskPromobar) {
    announcementResizeObserver.observe(qskPromobar);
  }
}

function observePromobarInjection(onResize) {
  updateAnnouncementBarOffset();
  observeAnnouncementBarResize(onResize);

  if (!document.body || typeof MutationObserver === 'undefined') return;

  if (promobarMutationObserver) {
    promobarMutationObserver.disconnect();
  }

  promobarMutationObserver = new MutationObserver(function() {
    if (promobarMutationRaf) return;
    promobarMutationRaf = requestAnimationFrame(function() {
      promobarMutationRaf = null;
      updateAnnouncementBarOffset();
      observeAnnouncementBarResize(onResize);
      if (typeof onResize === 'function') onResize();
    });
  });

  promobarMutationObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
}

function initHeaderTransparentOverlay(headerWrapper) {
  if (headerWrapper.getAttribute('data-transparent-overlay') !== 'true') return false;
  if (!isHeroFirstSection()) return false;

  updateAnnouncementBarOffset();
  document.body.classList.add('header-overlay-active');
  headerWrapper.classList.add('header-wrapper--transparent');
  return true;
}

function updateHeaderStuckTop() {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const overlayActive = document.body.classList.contains('header-overlay-active');
  const effectiveHeight = getCombinedAnnouncementHeight();
  const isSticky = hasStickyTopBar();

  const shouldStickTop = overlayActive
    ? scrollTop > HEADER_OVERLAY_SCROLL_THRESHOLD
    : isSticky
      ? false
      : scrollTop > effectiveHeight;

  if (shouldStickTop) {
    document.body.classList.add('header-stuck-top');
  } else {
    document.body.classList.remove('header-stuck-top');
  }
}

function updateHeaderScrollOffset() {
  updateAnnouncementBarOffset();
  updateHeaderStuckTop();
}

function updateHeaderOverlayScrollState(headerWrapper) {
  if (!document.body.classList.contains('header-overlay-active')) return;

  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  if (scrollTop > HEADER_OVERLAY_SCROLL_THRESHOLD) {
    headerWrapper.classList.add('header-wrapper--scrolled');
  } else {
    headerWrapper.classList.remove('header-wrapper--scrolled');
  }

  updateHeaderScrollOffset();
}

class StickyHeader extends HTMLElement {
constructor() {
super();
}

connectedCallback() {
this.header = document.querySelector('.section-header');
this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
this.headerBounds = {};
this.overlayActive = false;

updateAnnouncementBarOffset();
observePromobarInjection(this.setHeaderHeight.bind(this));

this.setHeaderHeight();

this.onHeaderLayoutResize = this.handleHeaderLayoutResize.bind(this);
window.matchMedia('(max-width: 990px)').addEventListener('change', this.onHeaderLayoutResize);
window.addEventListener('resize', this.onHeaderLayoutResize);

if (this.headerIsAlwaysSticky) {
this.header.classList.add('shopify-section-header-sticky');
};

this.overlayActive = initHeaderTransparentOverlay(this);
if (this.overlayActive) {
  this.setHeaderHeight();
  updateHeaderOverlayScrollState(this);
}

this.currentScrollTop = 0;
this.preventReveal = false;
this.predictiveSearch = this.querySelector('predictive-search');

this.onScrollHandler = this.onScroll.bind(this);
this.hideHeaderOnScrollUp = () => this.preventReveal = true;

this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.addEventListener('scroll', this.onScrollHandler, false);

this.createObserver();
}

setHeaderHeight() {
document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
}

handleHeaderLayoutResize() {
updateAnnouncementBarOffset();
this.setHeaderHeight();
}

disconnectedCallback() {
this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
window.removeEventListener('scroll', this.onScrollHandler);
window.removeEventListener('resize', this.onHeaderLayoutResize);
if (announcementResizeObserver) {
  announcementResizeObserver.disconnect();
  announcementResizeObserver = null;
}
if (promobarMutationObserver) {
  promobarMutationObserver.disconnect();
  promobarMutationObserver = null;
}
}

createObserver() {
let observer = new IntersectionObserver((entries, observer) => {
this.headerBounds = entries[0].intersectionRect;
observer.disconnect();
});

observer.observe(this.header);
}

onScroll() {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

if (this.overlayActive) {
updateHeaderOverlayScrollState(this);
} else {
updateHeaderScrollOffset();
}

if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (this.preventHide) return;
requestAnimationFrame(this.hide.bind(this));
} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
this.header.classList.add('scrolled-past-header');
if (!this.preventReveal) {
requestAnimationFrame(this.reveal.bind(this));
} else {
window.clearTimeout(this.isScrolling);

this.isScrolling = setTimeout(() => {
this.preventReveal = false;
}, 66);

requestAnimationFrame(this.hide.bind(this));
}
} else if (scrollTop <= this.headerBounds.top) {
this.header.classList.remove('scrolled-past-header');
requestAnimationFrame(this.reset.bind(this));
}

this.currentScrollTop = scrollTop;
}

hide() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
this.closeMenuDisclosure();
this.closeSearchModal();
}

reveal() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.add('shopify-section-header-sticky', 'animate');
this.header.classList.remove('shopify-section-header-hidden');
}

reset() {
if (this.headerIsAlwaysSticky) return;
this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
}

closeMenuDisclosure() {
this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
this.disclosures.forEach(disclosure => disclosure.close());
}

closeSearchModal() {
this.searchModal = this.searchModal || this.header.querySelector('details-modal');
this.searchModal.close(false);
}
}

customElements.define('sticky-header', StickyHeader);

document.addEventListener('DOMContentLoaded', function() {
  const headerWrapper = document.querySelector('div.header-wrapper[data-transparent-overlay="true"]');
  if (!headerWrapper || headerWrapper.closest('sticky-header')) return;

  const sectionHeader = document.querySelector('.section-header');
  const setHeight = function() {
    if (sectionHeader) {
      document.documentElement.style.setProperty('--header-height', `${sectionHeader.offsetHeight}px`);
    }
  };

  observePromobarInjection(setHeight);
  setHeight();

  const overlayActive = initHeaderTransparentOverlay(headerWrapper);
  if (!overlayActive) return;

  updateHeaderOverlayScrollState(headerWrapper);

  window.addEventListener('resize', function() {
    updateAnnouncementBarOffset();
    setHeight();
  });

  window.addEventListener('scroll', function() {
    updateHeaderOverlayScrollState(headerWrapper);
  }, { passive: true });
});

  } catch(e) { console.error(e); }
})();
})();
